import React, { useRef } from 'react'

import JoditEditor from 'jodit-react'
import styled from 'styled-components'

const RichTextbox = ({
  id,
  content,
  setContent,
  isReadOnly,
  className = '',
  errorMessage = '',
  title = '',
  required = false,
  marginBottom = '0px',
  buttons = [],
}) => {
  const editor = useRef(null)

  const config = {
    buttons:
      buttons.length > 0
        ? buttons
        : [
            'paragraph',
            'bold',
            'underline',
            'italic',
            '|',
            'ul',
            'ol',
            '|',
            'link',
            '|',
            'undo',
            'redo',
          ],
    readonly: isReadOnly | false,
    toolbarAdaptive: false,
  }

  return (
    <StyledJoditEditor
      id={id}
      marginBottom={marginBottom}
      hasError={className === 'has-error'}
    >
      {title && (
        <label>
          {title} {required && <span className="required">*</span>}
        </label>
      )}
      <JoditEditor
        {...(className && { className })}
        ref={editor}
        value={content}
        config={config}
        tabIndex={1} // tabIndex of textarea
        onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
      />
      {className === 'has-error' && (
        <sub style={{ color: 'red' }}>{errorMessage}</sub>
      )}
    </StyledJoditEditor>
  )
}

const StyledJoditEditor = styled.div`
  label {
    font-size: 0.875rem;
    font-weight: 300;
    color: ${(props) => (props.hasError ? 'red' : 'inherit')};
  }

  span.required {
    color: red;
  }

  .jodit-container {
    &.has-error {
      border: 1px solid red;
    }
  }

  margin-bottom: ${(props) => props.marginBottom};
  width: 100%;
`

export default RichTextbox
